import { ReportsView } from '../../features/reports/ReportsView'

/** S9 Reports (Fruuit staff). */
export function ReportsPage() {
  return <ReportsView area="workspace" />
}
